import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import { dashboardActions } from "redux/Ldb/actions";
import useInfiniteScroll from "hooks/useInfinteScroll";
import { fetchDashboardConfigListV2Request } from "services/Ldb/types/DashboardServices";

const useGetDashboardConfigListV2 = (
    request: fetchDashboardConfigListV2Request,
    options?: {
        isInfiniteScroll?: boolean;
        skip?: boolean;
    }
) => {
    const { isInfiniteScroll = false, skip = false } = options || {};
    const dispatch = useAppDispatch();
    const [configTableData, setConfigTableData] = useState<{ [key: string]: any }[]>([]);
    const [pagination, setPagination] = useState<{ currentPage: string; noOfPages: string }>({
        currentPage: "1",
        noOfPages: "",
    });

    const { updatedLimit, isLoadingMore, setLoadMore, updatedPage, setUpdatedPage } =
        useInfiniteScroll(
            { current: pagination.currentPage, number_of_pages: pagination.noOfPages },
            10,
            null,
            false,
            isInfiniteScroll
        );

    const {
        fetchingDashboardConfigList,
        fetchedDashboardConfigListSuccess,
        fetchedDashboardConfigListFailure,
    } = useAppSelector((state) => state.dashboard);

    useEffect(() => {
        if (Boolean(fetchedDashboardConfigListSuccess)) {
            setConfigTableData(fetchedDashboardConfigListSuccess?.inventories);
            setPagination({
                currentPage: fetchedDashboardConfigListSuccess?.pagination?.current,
                noOfPages: fetchedDashboardConfigListSuccess?.pagination?.number_of_pages,
            });
        }
    }, [fetchedDashboardConfigListSuccess]);

    useEffect(() => {
        if (!skip) {
            dispatch(dashboardActions?.getDashboardConfigListV2(request));
        }
    }, [dispatch, request, skip]);

    const handleRefetch = () => {
        dispatch(dashboardActions?.getDashboardConfigListV2(request));
    };

    return {
        data: configTableData,
        isFetching: fetchingDashboardConfigList,
        error: fetchedDashboardConfigListFailure,
        updatedPage,
        setUpdatedPage,
        pagination,
        refetch: handleRefetch,
        setPagination,
    };
};

export default useGetDashboardConfigListV2;
